// Brand terms that are NEVER translated
// These remain in English across all languages

export const BRAND = {
  // Company names
  COMPANY: {
    FULL: 'BrickPlease AI Enablement AB',
    SHORT: 'Brick',
  },

  // Product names - never translated
  PRODUCTS: {
    ALGORITHM_HOTEL: 'The Algorithm Hotel',
  },

  // Technical terms that stay in English
  TECHNICAL: {
    PROMPT_STACK: 'prompt stack',
    ROI: 'ROI',
    KPI: 'KPI',
    AI: 'AI',
    AGENTIC_FLOW: 'agentic flow',
    PROMPT_ENGINEERING: 'prompt engineering',
  },

  // Common CTAs and phrases
  PHRASES: {
    USAGE_NOT_IMPACT: 'Usage ≠ Impact',
  },
} as const;

// Flatten for easy interpolation in translations
export const brandTerms = {
  company: BRAND.COMPANY.SHORT,
  companyFull: BRAND.COMPANY.FULL,
  algorithmHotel: BRAND.PRODUCTS.ALGORITHM_HOTEL,
  promptStack: BRAND.TECHNICAL.PROMPT_STACK,
  roi: BRAND.TECHNICAL.ROI,
  kpi: BRAND.TECHNICAL.KPI,
  ai: BRAND.TECHNICAL.AI,
  agenticFlow: BRAND.TECHNICAL.AGENTIC_FLOW,
  promptEngineering: BRAND.TECHNICAL.PROMPT_ENGINEERING,
  usageNotImpact: BRAND.PHRASES.USAGE_NOT_IMPACT,
} as const;
